import React, {Component} from 'react';
import {BulletList} from '../../Common/PageComponents';

class AutoPaymentResetGuide extends Component {
  render() {
    return (
      <div>
        <div>
          ※ 자동결제 실패 시, 실패 안내 SMS가 전송되며 30분 후 자동결제를 재시도합니다. <br />
          &nbsp;&nbsp;&nbsp;&nbsp;자동결제 2회 실패 시 재시도 시점이 익일로 연기되오니, 실패 안내 SMS 수신 시 자동결제
          수단 점검을 부탁드립니다. <br />
          &nbsp;&nbsp;&nbsp;&nbsp;새벽시간(00:00~07:00)에 SMS 수신을 원하지 않을 경우, 수신안함을 선택해주시기 바랍니다.{' '}
          <br />
          <br />
        </div>
        <BulletList>
          <ul>
            <li>재인증 시 실제 결제는 이루어지지 않으며 기준 결제 시점에서만 자동 결제가 이루어 집니다.</li>
            <li>
              이후에는 재인증 시 사용하신 카드로 자동결제가 이루어지게 되오니, 변경을 원하시지 않을 경우 기존에
              사용하시던 카드를 통해 재인증을 부탁 드립니다.
            </li>
            <li style={{color: 'blue'}}>
              크롬 브라우저 사용 시 &quot;페이지 응답없음&quot; 오류 창이 나타날 경우, 오류창 내 대기 버튼 클릭이나
              무시하시고 진행해도 정상적으로 재인증이 완료됩니다.
            </li>
          </ul>
        </BulletList>
      </div>
    );
  }
}

export default AutoPaymentResetGuide;
